import { render } from "./oikomi.vue?vue&type=template&id=1bd1f038"
import script from "./oikomi.vue?vue&type=script&lang=js"
export * from "./oikomi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__